<template>
  <pt-life-experience-pavilion-reservation
  class="pt-life-experience-pavilion-reservation__withData" @reservationExport="reservationExport"
  ref="table" :waitAuditCount="waitAuditCount"></pt-life-experience-pavilion-reservation>
</template>

<script>
import PtLifeExperiencePavilionReservation from './index'
export default {
  name: 'pt-life-experience-pavilion-reservation__withData',
  components: {
    'pt-life-experience-pavilion-reservation': PtLifeExperiencePavilionReservation
  },
  data () {
    return {
      waitAuditCount: 0
    }
  },
  methods: {
    reservationExport (params) {
      const {
        reservationDate,
        createdDate,
        time,
        searchKey
      } = params

      const reservationStartTime = reservationDate ? reservationDate.reservationStartTime : ''
      const reservationEndTime = reservationDate ? reservationDate.reservationEndTime : ''
      const createdStartTime = createdDate ? createdDate.createdStartTime : ''
      const createdEndTime = createdDate ? createdDate.createdEndTime : ''
      const timeIds = time ? [time] : null
      const type = 'DATA'

      const data = {
        pageable: {
          page: this.page,
          size: this.pageSize
        },
        reservationStartTime,
        reservationEndTime,
        createdStartTime,
        createdEndTime,
        timeIds,
        searchKey,
        type
      }
      this.exportLoading = true
      this.$store.dispatch('reservationExport', data).then(res => {
        this.exportLoading = false
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message.error(err || '导出生命体验馆预约失败')
      })
    },
    getWaitAuditCount () {
      this.$store.dispatch('getWaitAuditCount').then(res => {
        this.waitAuditCount = res
      }).catch(err => {
        this.$message.error(err || '获取待审核数量失败')
      })
    }
  },
  created () {
    this.getWaitAuditCount()
  }
}
</script>
